import { ElasticSearchResponse, Pack, PackDocument } from '@shared/services/elastic-search/models';

export const packsSerializer = (packs: ElasticSearchResponse<PackDocument>): Pack[] =>
  packs.hits.hits.map((pack) => {
    const p = pack._source;
    return {
      price: p.pack_promo?.[0] ?? '',
      newPrice: p.pack_price?.[0] ?? '',
      ecoPart: p.field_eco_part_pack?.[0] ?? '',
      products: p.products,
    };
  });
